<section>
    @if(btn) {
        <tilby-general-input-button [btn]="btn"/>
    }
</section>
@if(!isMobile || showTitle) {
    <section class="tw-flex tw-items-center tw-truncate">
        <span class=" tw-text-[1.6em] tw-ml-7" [appTruncatedText]="label">{{label}}</span>
    </section>
}
